import { render, staticRenderFns } from "./ApprovalActions.vue?vue&type=template&id=a3ebed2a"
import script from "./ApprovalActions.vue?vue&type=script&lang=ts"
export * from "./ApprovalActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports